import type { ToastProps } from '.';

import Toast from '.';

const ErrorToast = ({ children, ...props }: ToastProps) => (
  <Toast ariaProps={{ 'aria-live': 'assertive', role: 'alert' }} kind="error" {...props}>
    {children}
  </Toast>
);

export default ErrorToast;
